export const RenderPendantSelectionLabel = ({
  variantName,
  isBirthstoneStep,
  currentPendantSummaryName,
  metadataVariantName
}: {
  variantName: string
  isBirthstoneStep: boolean | undefined
  currentPendantSummaryName: string | undefined
  metadataVariantName: string
}) => {
  if (!currentPendantSummaryName) return <p className="text-xs text-subdued font-calibre capitalize">{variantName}</p>

  if (isBirthstoneStep) {
    return <p className="text-xs text-subdued font-calibre capitalize">{`${currentPendantSummaryName}: ${variantName} (${metadataVariantName})`}</p>
  }

  return <p className="text-xs text-subdued font-calibre capitalize">{`${currentPendantSummaryName}: (${variantName})`}</p>
}
